<div class="container-flex"  style="margin: 0px 10px;">
    <!-- <div class="row">
        <div class="col-12">
            <p style="font-family: roboto, sans-serif">Search for a place here:</p>
        </div>
        <div class="col-8" id="rsg_placesAutocompelete">
            <span>auto complete here.</span>
        </div>
    </div> -->
    <!-- <div class="row">
        <div class="col-12">
            <h2>Delivery Rate Finder</h2>
        </div>
    </div> -->
    <div class="row" style="padding-bottom: 0px;">
        <div class="col-1"></div>
        <div class="col-7" id="rsg_placesAutocompelete" *ngIf="loadMap">
            <input 
                id="rsg-address-input"
                class="controls"
                type="text"
                placeholder="Enter destination address"
                style="width: 100%;"
                [(ngModel)]="addressInput"
            />
        </div>
        <div class="col-7" *ngIf="!loadMap">
            <mat-progress-bar *ngIf="!loadMap" mode="indeterminate" style="height:20px"></mat-progress-bar>
        </div>
        <div class="col-3">
            <button mat-raised-button color="primary" class="fill-w"  (click)="getAddress()" [disabled]="!loadMap" >Get Rates</button>
        </div>
    </div>
    <div class="row">
        <div class="col-1"></div>
        <div class="col-7">
            <google-map *ngIf="loadMap"
                height="65vh"
                width="100%"
                [options] = "options"
                (mapClick)="moveMap($event)"
                (mapMousemove)="move($event)"
                (mapDblclick)="mapDblclick($event)"
                (mapInitialized)="mapInitialized($event)"
            ></google-map>
            <mat-progress-bar *ngIf="!loadMap" mode="indeterminate" style="height: 300px;"></mat-progress-bar>
        </div>
        <div class="col-3">
            <div class="row" style="padding-top: 15px;">
                <div class="col-7"><strong>Name</strong></div>
                <div class="col-3"><strong>Haul Rate</strong></div>
                <div class="col-2"><strong>Zone</strong></div>
                <hr class="hr-short">
            </div>
            <div class="row" *ngIf="loadingRates">
                <div class="col-12">
                    Calculating Haul Rates<br>
                    <mat-progress-bar  mode="indeterminate" style="height: 35px;" class="fill-w"></mat-progress-bar>
                </div>
            </div>
            <span *ngIf="!loadingRates">
                <div class="row"  *ngFor="let rate of deliveryRates">
                    <div class="col-7">{{rate.quarry.name}}</div>
                    <div class="col-3">
                        <span *ngIf="rate.hasRate">${{rate.formatedDeliveryRate}}/ton</span>
                        <span *ngIf="!rate.hasRate">not available</span>
                    </div>
                    <div class="col-2">
                        <span *ngIf="rate.distance !== null">{{rate.distance.name}}</span>
                        <span *ngIf="rate.zone !== null">{{rate.zone.name}}</span>
                    </div>
                    <hr class="hr-short">
                </div>
            </span>
            
            <div class="row" *ngIf="rateSource.lat !== ''">
                <div class="col-12"><strong>Delivery Address:</strong></div>
                <div class="col-12">{{rateSource.rateAddress}}</div>
                <div class="col-12"><small><i>Latitude: </i>{{rateSource.lat}}</small></div>
                <div class="col-12"><small><i>Longitude: </i>{{rateSource.lng}}</small></div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-1"></div>
        <div class="col-3" *ngIf="loadMap">
            <div>Latitude: {{display?.lat}} </div>
            <div>Longitude: {{display?.lng}}</div>
        </div>
        <div class="col-7" >
            <i>New: Double click anywhere on the map to place a marker to get rates. Double click again to clear the marker.</i>
        </div>
    </div>
    
    <!-- style="display: none" -->
    <!-- <div class="row" >
        <div >
            <input
                id="origin-input"
                class="controls"
                type="text"
                placeholder="Enter an origin location"
            />
        
            <input
                id="destination-input"
                class="controls"
                type="text"
                placeholder="Enter a destination location"
            />
      
            <div id="mode-selector" class="controls">
                <input
                    type="radio"
                    name="type"
                    id="changemode-walking"
                    checked="checked"
                />
                <label for="changemode-walking">Walking</label>
        
                <input type="radio" name="type" id="changemode-transit" />
                <label for="changemode-transit">Transit</label>
        
                <input type="radio" name="type" id="changemode-driving" />
                <label for="changemode-driving">Driving</label>
            </div>
        </div>
      
        <div id="map2" style="height: 500px;"></div>
    </div> -->
</div>